import React, { useState, useEffect } from 'react';
import { MisEntradas } from '../modules/congreso';
import PageTitle from '../components/PageTitle';
import Forbidden from './shared/Forbidden';
import DefaultLayout from '../layout/DefaultLayout';

export const CongresoPage: React.FC = () => {
  const [featureFlagActiva, setFeatureFlagActiva] = useState<boolean | null>(null);

  useEffect(() => {
    const checkFeatureFlag = async () => {
      try {
        setFeatureFlagActiva(true); 
      } catch (err) {
        setFeatureFlagActiva(false);
      }
    };

    checkFeatureFlag();
  }, []);

  if (featureFlagActiva === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!featureFlagActiva) {
    return <Forbidden />;
  }

  return (
    <DefaultLayout>
      <PageTitle title="Mis Entradas - Congreso" />
      <MisEntradas />
    </DefaultLayout>
  );
};

export default CongresoPage;


